// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"2da86edf","453":"54292a4b","879":"bc896dd3"}[chunkId] + ".chunk.js";
};